import { defineComponent as _defineComponent } from 'vue'
import { translateLang } from '@/data/i18n/translateLang'
import { computed } from 'vue'

interface LegendItem {
  key: string
  label: Parameters<typeof translateLang>[0]
  icon?: boolean
  isClassify?: boolean
  tagText?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-folder-legend',
  setup(__props) {

const legendItems = computed<LegendItem[]>(() => [
  {
    key: 'fixedFolder',
    label: '固定文件夹',
    icon: true,
  },
  {
    key: 'classifyFolder',
    label: '分类文件夹',
    icon: true,
    isClassify: true,
  },
  {
    key: 'fixedTag',
    label: '固定数据',
    tagText: '订单号',
  },
  {
    key: 'normalTag',
    label: '动态数据',
    tagText: '{订单号}',
  },
  {
    key: 'classifyTag',
    label: '分类动态数据',
    tagText: '{订单号}',
    isClassify: true,
  },
])

return { __sfc: true,legendItems, translateLang }
}

})